<span><topo-color-display [htmlColorCode]="value"></topo-color-display></span>
